<template>
  <div>
    <div class="card no-margin-bottom">
      <div class="card-block">
        <ui-data-table
          id="products-colors-maps-list"
          ref="list"
          :columns="columns"
          :filters="filters"
          :endpoint="endpoint"
          :actions="actions"
          size="sm"
        >
          <template
            slot="id"
            slot-scope="row"
          >
            <a
              href="#"
              @click.prevent="openEditModal(row.id)"
            >
              {{ row.id }}
            </a>
          </template>
          <template
            slot="actions"
            slot-scope="row"
          >
            <a
              href="#"
              class="text-danger"
              @click.prevent="remove(row.id)"
            >
              <i
                :title="$t('Delete')"
                class="fa fa-trash"
              />
            </a>
          </template>
        </ui-data-table>
      </div>
    </div>
    <app-colors-maps-edit-modal
      v-model="edit.visible"
      :color-map-id="edit.id"
      @saved="onUpdate"
    />
    <app-colors-maps-add-modal
      v-model="add.visible"
      @saved="onUpdate"
    />
  </div>
</template>

<script>
import ApiService from '../services/ApiService';
import ErrorsMixins from '../mixins/ErrorsMixins';
import Languages from '../components/Localization/Languages';
import ColorsMapsService from '../services/ColorsMapsService';
import AppColorsMapsEditModal from '../components/colors-maps/ColorsMapsEditModal.vue';
import AppColorsMapsAddModal from '../components/colors-maps/ColorsMapsAddModal.vue';

export default {
  name: 'AppPageProductsColorsMaps',
  components: {
    AppColorsMapsAddModal,
    AppColorsMapsEditModal,
  },
  mixins: [ErrorsMixins],
  data() {
    const columns = [
      {
        name: 'ID',
        key: 'id',
        sorting: true,
        styles: 'text-right',
      },
    ];
    const filters = [
      {
        name: 'ID',
        key: 'id',
        type: 'integer',
      },
    ];
    Languages.codes().forEach(code => {
      columns.push({
        name: code.toUpperCase(),
        key: code,
      });
      filters.push({
        name: code.toUpperCase(),
        key: code,
        type: 'string',
      });
    });
    columns.push({
      name: this.$tc('Actions', 2),
      key: 'actions',
      styles: 'text-center',
    });
    return {
      columns,
      filters,
      endpoint: ApiService.getLink('colors/maps'),
      actions: [
        {
          icon: 'fa fa-plus',
          action: () => {
            this.openAddModal();
          },
          label: this.$t('Create object', { object: this.$tc('Colors Maps', 1).toLowerCase() }),
        },
      ],
      edit: {
        visible: false,
        id: 0,
      },
      add: {
        visible: false,
      },
    };
  },
  methods: {
    refresh() {
      this.$refs.list.refresh();
    },
    remove(id) {
      // eslint-disable-next-line
      if (confirm(this.$t('Are you sure?'))) {
        this.loading = true;
        ColorsMapsService.remove(id).then(() => {
          this.loading = false;
          this.$notifications_success(this.$t('Action', { object: this.$tc('Colors Maps', 1), action: this.$t('deleted') }));
          this.refresh();
        }).catch(() => {
          this.$errors_showNetworkErrorMessage();
          this.loading = false;
        });
      }
    },
    openEditModal(id) {
      this.edit = {
        visible: true,
        id,
      };
    },
    openAddModal() {
      this.add = {
        visible: true,
      };
    },
    closeAddModal() {
      this.add = {
        visible: false,
      };
    },
    onUpdate() {
      this.closeAddModal();
      this.refresh();
    },
  },
};
</script>
